import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CanvasService } from '../../../services/canvas/canvas.service';
import { GeneralShape } from '../../../element-editor/shape/shapes/general/general-shape';
import { ShapeService } from '../../../element-editor/shape/shape.service';

@Component({
  selector: 'nw-shape-selector',
  templateUrl: './shape-selector.component.html',
  styleUrls: ['./shape-selector.component.scss'],
})
export class ShapeSelectorComponent {
  @Input()
  shapeTypes?: string[];

  @Input()
  key: string;

  @Input()
  value: string;

  @Output()
  changed = new EventEmitter<any>();

  get selectedShape() {
    // console.log('value', this.value);
    return this.value ? this.shapeService.getResource(this.value) : undefined;
  }

  get shapes() {
    return this.shapeService.previewShape.shapes.filter(shape => {
      if (shape.selected) {
        return false;
      }
      if (this.shapeTypes?.length) {
        return this.shapeTypes.includes(shape.getType());
      }
      return true;
    });
  }

  constructor(
    private readonly cs: CanvasService,
    private readonly shapeService: ShapeService,
  ) {}

  shapeChanged(shape: GeneralShape) {
    this.changed.emit(shape.IRI);
  }
}
